import _jsx from "@babel/runtime/helpers/jsx";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _FilterCheckboxesBloc, _ResetFiltersButton;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useCallback, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import FilterCheckboxesBlocks from 'components/FilterCheckboxesBlocks';
import FilterCheckboxesBlock from 'components/FilterCheckboxesBlock';
import MultiSelect from 'components/SelectMultiple';
import Select from 'components/Select';
import ResetFiltersButton from 'components/ResetFiltersButton';
import { newSearch, newPathname } from 'utils';
import { useSelectorProps } from 'hooks';
import { getFormattedSearchParams, getCurrenciesOptions } from 'selectors';
import { ACTIVITY_TYPE, CLIENT_TYPES, ACTIVITY_TYPE_KEYS } from 'constants/filters';
import { MainFiltersWrapper, MoreFiltersWrapper } from './styles';

function MoreFilters() {
  var _searchParams$currenc;

  var selectorProps = useSelectorProps();
  var formatMessage = selectorProps.intl.formatMessage;
  var history = useHistory();
  var activityTypeOptions = useMemo(function () {
    return Object.keys(ACTIVITY_TYPE).reduce(function (res, activity) {
      return _objectSpread(_objectSpread({}, res), {}, _defineProperty({}, activity, {
        label: formatMessage({
          id: "MoreFilters.multiSelect.activityType.".concat(activity)
        }),
        value: activity
      }));
    }, {});
  }, [ACTIVITY_TYPE]);
  var searchParams = useSelector(function (state) {
    return getFormattedSearchParams(state, selectorProps);
  });
  var currenciesOption = useSelector(function (state) {
    return getCurrenciesOptions(state, selectorProps);
  });
  var clientType = selectorProps.params.clientType;
  var activityTypesSet = new Set(searchParams.activityType || []);

  if (clientType === CLIENT_TYPES.it) {
    activityTypesSet.add(ACTIVITY_TYPE_KEYS.it);
  }

  var defaultValuesActivityType = Array.from(activityTypesSet);
  var handleValue = useCallback(function (newObj) {
    var _newObj$activityType;

    return history.push({
      pathname: newObj != null && (_newObj$activityType = newObj.activityType) != null && _newObj$activityType.find(function (el) {
        return el === ACTIVITY_TYPE_KEYS.it;
      }) && clientType === CLIENT_TYPES.it ? selectorProps.location.pathname : newPathname({
        params: selectorProps.params,
        newValues: {
          clientType: null
        }
      }),
      search: newSearch({
        params: searchParams,
        newValues: clientType === CLIENT_TYPES.it ? _objectSpread(_objectSpread({}, newObj), {}, {
          activityType: newObj.activityType.filter(function (el) {
            return el !== ACTIVITY_TYPE_KEYS.it;
          })
        }) : newObj
      })
    });
  }, [selectorProps]);
  return /*#__PURE__*/_jsx(MoreFiltersWrapper, {}, void 0, /*#__PURE__*/_jsx(MainFiltersWrapper, {}, void 0, /*#__PURE__*/_jsx(MultiSelect, {
    name: "activityType",
    label: formatMessage({
      id: 'MoreFilters.multiSelect.activityType'
    }),
    defaultValues: defaultValuesActivityType,
    placeholder: formatMessage({
      id: 'MoreFilters.multiSelect.activityType.placeholder'
    }),
    autocompletePlaceholder: formatMessage({
      id: 'MoreFilters.multiSelect.activityType.autocompletePlaceholder'
    }),
    options: activityTypeOptions,
    handleValue: handleValue
  }), /*#__PURE__*/_jsx(FilterCheckboxesBlock, {
    block: "monthlyFee",
    blockItems: ['free'],
    isWithoutWidth: true,
    isCustomTitleMargin: true
  }), /*#__PURE__*/_jsx(Select, {
    options: currenciesOption,
    defaultValue: (searchParams == null ? void 0 : (_searchParams$currenc = searchParams.currency) == null ? void 0 : _searchParams$currenc[0]) || '',
    name: "currency",
    label: formatMessage({
      id: 'MoreFilters.select.currency'
    }),
    placeholder: formatMessage({
      id: 'MoreFilters.select.currency.placeholder'
    }),
    autocompletePlaceholder: formatMessage({
      id: 'MoreFilters.select.currency.autocompletePlaceholder'
    }),
    onChange: handleValue
  })), _FilterCheckboxesBloc || (_FilterCheckboxesBloc = /*#__PURE__*/_jsx(FilterCheckboxesBlocks, {})), _ResetFiltersButton || (_ResetFiltersButton = /*#__PURE__*/_jsx(ResetFiltersButton, {})));
}

export default MoreFilters;